/**
 * Pure helpers for multi-challenge creation flow.
 * Extracted from CreateChallengePage for testability.
 */

/**
 * Check whether an event starts in the future.
 * Supports multiple date field names: startDate, eventDate, date.
 */
export const isFutureEvent = (event) => {
  const startDate = event?.startDate || event?.eventDate || event?.date;
  if (!startDate) return false;
  return new Date(startDate).getTime() > Date.now();
};

/**
 * Find IDs of events that have already started (not future).
 * Used to validate multi-select external events before submission.
 */
export const findNonFutureEventIds = (eventIds, events) => eventIds.filter((eid) => {
  const ev = events.find((e) => String(e.externalId) === String(eid));
  return ev && !isFutureEvent(ev);
});

/**
 * Build per-event overrides for multi-challenge creation.
 * Each challenge gets its own externalEventId and betDeadline from the match's startDate.
 */
export const buildMultiChallengeOverrides = (externalEventIds, externalEvents) =>
  externalEventIds.map((eid) => {
    const matchEvent = externalEvents.find((ev) => String(ev.externalId) === String(eid));
    const matchBetDeadline = matchEvent?.startDate || matchEvent?.eventDate || matchEvent?.date || null;
    return { externalEventId: eid, eventId: null, betDeadline: matchBetDeadline };
  });

/**
 * Validate external event selection for multi-create.
 * Returns an object with errors, or empty object if valid.
 */
export const validateExternalEventSelection = (externalEventIds, externalEventId, selectedExternalEvent, externalEvents) => {
  const errors = {};
  const hasSelection = externalEventIds.length > 0 || externalEventId;

  if (!hasSelection) {
    errors.externalEventId = 'Выберите хотя бы один матч из внешнего API';
    return errors;
  }

  if (externalEventIds.length > 1) {
    const nonFutureIds = findNonFutureEventIds(externalEventIds, externalEvents);
    if (nonFutureIds.length > 0) {
      errors.externalEventId = 'Некоторые выбранные матчи уже начались';
    }
    return errors;
  }

  // Single selection
  if (externalEventIds.length === 0 && externalEventId && !selectedExternalEvent) {
    errors.externalEventId = 'Выбранный матч не найден';
  } else if (selectedExternalEvent && !isFutureEvent(selectedExternalEvent)) {
    errors.externalEventId = 'Выберите матч, который ещё не начался';
  }

  return errors;
};

/**
 * Check whether submit should be disabled for external event source.
 */
export const isExternalSubmitDisabled = (externalEventIds, externalEventId, availableExternalEvents) => {
  const hasExternalSelection = externalEventIds.length > 0 || externalEventId;
  return availableExternalEvents.length === 0 || !hasExternalSelection;
};

/**
 * Get the submit button label for challenge creation.
 */
export const getSubmitButtonLabel = (isEditMode, eventSource, externalEventIdsLength) => {
  if (isEditMode) return 'Сохранить';
  if (eventSource === 'external' && externalEventIdsLength > 1) {
return `Создать ${externalEventIdsLength} пари`;
  }
return 'Создать пари';
};

/**
 * Check whether manual betDeadline input should be hidden (multi-select mode).
 */
export const shouldHideBetDeadlineInput = (eventSource, externalEventIdsLength) =>
  eventSource === 'external' && externalEventIdsLength > 1;
